export enum ExperimentCategories {
  TEXT = "text",
  ASSET = "asset",
  TRANSFORM = "transform",
  COLOR = "color",
  UNDEFINED = "Undefined",
}
